import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalResultsServicesService {
  viewType: 'Vertical' | 'Horizontal' = 'Vertical';
  disableHeaderButton: boolean = false;
  disabledStartProcessButton:boolean = true;

  // Tracks which workflow is currently active so the header can disable conflicting buttons.
  // 'itr' = Process ITR upload/review in progress
  // '26as' = Process 26-AS data loaded and under review
  // 'financial' = Process Financial PDF loaded and under review
  // null = no workflow active (all buttons enabled)
  activeWorkflow: 'itr' | '26as' | 'financial' | null = null;

  private dataSubject = new BehaviorSubject<{
    pdfSrc: string; jsonData: any; ackno: string | null; uploadedFileName: string | null;
  } | null>(null);

  data$ = this.dataSubject.asObservable();
  fixedRemarkForITR:string = '';
  extractedAckNo:any[] = [];
  itrZipJsonResult:any[]= [];
  updateUnMatchCriteriaArr:any [] = [];
  selectedType:string = "";
  pdfSrc: any;
  JSonResult: any = {};
  itrResult:any = {};

  // Store unmatched results, indexed by acknowledgment number
  unMatchedResults: { [ackNumber: string]: any } = {};
  
  // For display in the modal
  processedMismatches: any = null;
  clientData: any = null;
  itrData: any = null;

  clientMisMatchRes:any = {};
  itrMisMatchRes:any = {};

  statusDropdownJson:any = {};

  viewButton : boolean = true;
  disableView: boolean = true;
  disableSave:boolean = true;
  disableCancel: boolean = false;
  poFileName:string = "";

  pageNumber:number = 0;
  totalPages:number = 0;

  /*** 26As - Start ***/
    annualTaxJsonResult: any = {};
  /*** 26As - End ***/
  
  constructor(private toastr:ToastrService) { }

  setProcessedData(pdfSrc: any, jsonData: any = null, ackno: string | null = null, uploadedFileName: string | null = null): void {
    if (pdfSrc === null) {
      this.dataSubject.next(null);
    } else {
      this.dataSubject.next({ pdfSrc, jsonData, ackno, uploadedFileName });
    }
  }

  clear(): void {
    this.dataSubject.next(null);
    this.pdfSrc = null;
  }

  getProcessedData(): { pdfSrc: string; jsonData: any; ackno: string | null } | null {
    return this.dataSubject.value;
  }

  showPDFFile = (pdfFile: any) => {
    const id = '#fileInvoice';
    let $img: any = document.querySelector(id);
    if (typeof (FileReader) !== 'undefined') {
      let reader = new FileReader();

      reader.onload = (e: any) => { 
        const byteArray = e.target.result;
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        this.pdfSrc = URL.createObjectURL(blob);
      };
      reader.readAsArrayBuffer($img.files[0]);
    }
  }

  fileToBase64(file: File): Observable<string> {
    return from(
      new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const result = reader.result as string;
          resolve(result);
        };
        reader.onerror = error => reject(error);
        reader.readAsDataURL(file);
      })
    );
  }
     
  validatePattern(input:any) {
    const regex = /^[A-Za-z]{5}\d{4}[A-Za-z]$/;
    if (regex.test(input)) {
      return true; 
    } else {
      return false;
    }
  }


}

